// extracted by mini-css-extract-plugin
export default {"container":"wwjeQsOCYAKodlSBo1uu","headline":"NmV1vY5yAmxvO0k1PKMo","shareButtons":"iPWtB6vzLYmYi2tnYggR"};